/**
 * Created by richardlovejoy on 2/15/17.
 */
import {m4} from '../../utils/math/m4';

const PhantomScene3D = {

  init(objects, camera, width, height) {

    // save the camera and dims
    this.setViewport(camera, width, height);

    // balls are added later
    this.balls = [];

    return this;
  },

  setViewport(camera, width, height) {

    // width/height should always equal aspect ratio of 1024/675 (I think)
    var fullWidth = width*camera.sceneScale;
    var fullHeight = height*camera.sceneScale;
    //var fudgex = camera.projectorFudge.x * width/1024;
    //var fudgey = camera.projectorFudge.y * height/675;

    this.camera = camera;
    this.camera.init(57);
    this.viewport = {x: 0, y: 0, width, height};
    //this.camera.setViewOffset(fullWidth, fullHeight, (fullWidth-(width+fudgex))/2, (fullHeight-(height+fudgey))/2, width, height);

  },

  addBall(position, radius) {

    var sphere = {
      position: {...position},
      radius,
      userData: {screen: {x: 0, y: 0, z: 0, w: 1}}
    };
    this.balls.push(sphere);

    return sphere;

  },

  render() {

    // transform the balls to screen coords
    this.balls.forEach(obj => {

      // transform
      this.camera.worldToScreen(obj.position, this.viewport, obj.userData.screen);

    });


  }
};

export default PhantomScene3D;


// WEBPACK FOOTER //
// ./app/src/display/scene/PhantomScene3D.js